import FileAccessed from './FileAccessed';
import FileDownloaded from './FileDownloaded';

const SharePointFileOperation = {
    FileAccessed,
    FileDownloaded,
};

export default SharePointFileOperation;
